import { getValue } from "@nitro/gatsby-source-harvia-pim/helpers/attribute"
import { Product } from "@nitro/gatsby-source-harvia-pim/types/plugin"
import React from "react"
import AbbrBox from "../../atoms/AbbrBox"

//import * as styles from "./ProductMarketAreas.module.scss"

// https://www.nationsonline.org/oneworld/country_code_list.htm
export const MarketAreaMap: Record<string, string> = {
  arab_countries: "ARAB",
  asian_countries: "ASIA",
  china: "CN",
  cis_countries: "CIS",
  eu_countries: "EU",
  Europe: "EUR",
  europe_east: "EEU",
  europe_east_arabic: "EEA",
  finland: "FI",
  russia: "RU",
  germany: "DE",
  global: "Global",
  north_america: "NA",
}

type ProductMarketAreasProps = { product: Product }

const ProductMarketAreas: React.FC<ProductMarketAreasProps> = props => {
  //console.log('Rendering ProductMarketAreas', props)
  const marketAreas = getValue(props.product.values, "market_areas")

  if (!marketAreas) return null

  return (
    <span>
      {marketAreas.value.map(itm => (
        <AbbrBox key={itm.label} label={MarketAreaMap[itm.text]} title={itm.label} />
      ))}
    </span>
  )
}

export default ProductMarketAreas
